import { Component, inject } from '@angular/core'

import { DialogRef, DIALOG_DATA } from '@hyperkit'
import { IconTypes } from 'pkgs/hyperkit/src/components/icon/icon.component.types'

@Component({
  standalone: false,
  selector: 'api-key-dialog',
  templateUrl: './api-key-dialog.component.html',
  styleUrls: ['./api-key-dialog.component.scss'],
})
export class APIKeyDialogComponent {
  dialogRef = inject(DialogRef)
  data = inject<{
    apiKey: string
    keyName: string
  }>(DIALOG_DATA, { optional: true })

  public copied = false
  public readonly copyIcon = IconTypes.Copy
  public readonly checkIcon = IconTypes.Check

  public writeToClipboard(key: string): void {
    this.copied = true
    setTimeout(() => {
      this.copied = false
    }, 2000)
    navigator.clipboard.writeText(key)
  }

  public onClose(): void {
    this.dialogRef.close()
  }
}
